globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modules = appCustomerSpace.Modules || {};
appCustomerSpace.Modules.Charts = appCustomerSpace.Modules.Charts || {};

appCustomerSpace.Modules.Charts.lang = {
  t: function(path) {
    var translation = undefined,
        pathArray = path.split('.');

    for(var i = 0; i < pathArray.length; i++) {
      translation = (translation || this)[pathArray[i]];

      if(!translation) break;
    }

    return translation || ('Missing translation for : ' + path);
  },
  commons: {
    seeMore: 'Voir plus',
    seeLess: 'Tout cacher',
    seeAll: 'Tout afficher',
    visitsNb: 'Nb de visites'
  },
  highcharts: {
    months: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',  'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
    weekdays: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
    shortMonths : ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil', 'Août', 'Sep', 'Oct', 'Nov', 'Déc']
  },
  periodRanges: {
    all: 'Toutes les données',
    thisWeek: 'Cette semaine',
    lastWeek: 'La semaine dernière',
    twoWeeksAgo: 'Il y a deux semaines',
    lastSemester: 'Dernier semestre',
    beforeLastSemester: 'Avant dernier semestre'
  }
}
